import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'accredible-top-border-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './top-border-card.component.html',
  styleUrl: './top-border-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopBorderCardComponent {
  backgroundColor = input<string>('var(--color-white)');
  borderColor = input<string>('#5B4DFC');
}
